import React from 'react';

import Typography from '@smart-tv/components/typography';

import PlayerDevicesContext from '../player-devices-context';
import styles from './player-devices-dialog.module.scss';

export const PlayerDevicesDialogEditScreenHeader = () => {
  const { devices } = React.useContext(PlayerDevicesContext);

  const removableDevices = devices?.filter(({ active }) => !active);

  return (
    <React.Fragment>
      {removableDevices?.length === 0 ? (
        <Typography
          variant="h6"
          className={styles['player-devices-dialog-edit-screen__header']}
        >
          Alle enheder er nu fjernet
        </Typography>
      ) : (
        <Typography
          variant="h3"
          className={styles['player-devices-dialog-edit-screen__header']}
        >
          Administrér enheder
        </Typography>
      )}
    </React.Fragment>
  );
};

export default PlayerDevicesDialogEditScreenHeader;
